<template>
  <div class="card p-2" style="min-height: 200px">
    <div class="table-responsive">
      <table class="table">
        <thead>
          <tr>
            <th>Consumption Date</th>
            <th>Consumption No</th>
            <th>Warehouse</th>
            <th>Note</th>
            <th>Status</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="consumption in consumptionList" :key="consumption.id">
            <td>{{ consumption.date }}</td>
            <td>{{ consumption.consumption_number }}</td>
            <td>{{ consumption.warehouse_name }}</td>
            <td>{{ consumption.note }}</td>
            <td>{{ consumption.status }}</td>
            <td><button @click="goToEdit(consumption.id)" class="btn btn-sm btn-primary"><i class="fas fa-eye"></i></button></td>
          </tr>
        </tbody>
      </table>
      <!-- <p v-if="!journals.length" class="text-center mt-5">No data</p> -->
    </div>
  </div>
</template>

<script setup>
import { useRoute, useRouter } from 'vue-router';
const router = useRouter();
const route = useRoute();

const $props = defineProps({
  consumptionList: {
    type: Array,
    default: []
  }
})

const goToEdit = (id) => {
  router.push({ name: 'stock-consumption-edit',
    query: route.query,
    params: { ...route.params, consumptionId: id }
   });
}
</script>
